<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
      :title="page"
      icon="flash_on"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row>
        <v-card
          class="mt-5 mx-5 pa-10"
          tile
        >
          <h2>Termini e Condizioni</h2>
          <v-container>
            <p>Per accedere al servizio di prenotazione tavoli è necessario disporre di un account WhatsApp attivo</p>
            <v-container>
              <h3>Scopo del servizio</h3>
              <ol>
                <li>
                  Il servizio directBooking è stato creato per consentire agli utenti di prenotare direttamente la loro esperienza a DEMO in autonomia, scegliendo Data, orario e collocazione del tavolo.
                </li>
                <li>
                  Il servizio consente altresì di anticipare richieste, sia relative agli alimenti che ad eventuali richieste od esigenze specifiche.
                  <br> consente altresì di cancellare, sempre in autonomia e con un semplice tocco sul messaggio WhatsApp, la propria prenotazione 
                </li>
                <li>
                  L'applicazione ha lo scopo di offrire a tutti i clienti la migliore esperienza a DEMO, evitando o riducendo il più possibile le eventuali attese.
                </li>
              </ol>
            </v-container>
            <v-container>
              <h3>Funzionamento</h3>
              <ol>
                <li>
                  Il sistema richiede venga scelto il giorno della prenotazione, indicato il numero degli ospiti e scelto il posizionamento del tavolo (sala Interna o Dehors - riscaldato ove necessario).
                </li>
                <li>
                  Forniti tali dati il sistema li elabora e visualizza le disponibilità (o meno) nei vari orari.
                  Una volta selezionato l'orario disponibile più confacente alle proprie necessità è possibile indicare alcune opzioni (richiesta pizza senza glutine etc ).
                </li>
                <li>
                  Infine, viene richiesto un nominativo ed il numero di WhatsApp per la validazione della prenotazione.
                  Vi è inoltre la possibilità di inviare un messaggio di accompagnamento, qualora necessario.
                </li>
                <li>
                  Inseriti tutti i dati obbligatori il pulsante "Procedi" si attiva ed è possibile inviare la richiesta di Prenotazione.
                  <br>Qualora uno dei dati obbligatori sia mancante cliccando sul pulsante "Procedi" apparirà l'elenco dei dati mancanti.
                </li>
                <li>
                  Contestualmente all'invio della richiesta di prenotazione riceverete un messaggio di WhatsApp proveniente dal nostro Sistema.
                  Questo conterrà i dati salienti della vostra richiesta di prenotazione e vi esorterà a cliccare sul pulsante posto in fondo per validare la prenotazione.
                </li>
                <li>
                  Essendo la prenotazione a questo punto non ancora accettata, altre richieste di prenotazione verranno generate, e qualora fossero validate prima della vostra, potrebbe accadere che la vostra richiesta venga rifiutata per sopraggiunta indisponibilità.
                </li>
                <li>
                  Dopo aver cliccato su "Valida Prenotazione" riceverete entro pochi secondi un nuovo messaggio WhatsApp dove verrà (di norma) confermata la vostra prenotazione.
                  <br>
                  La procedura è virtualmente conclusa e vi attendiamo per il giorno e l'ora selezionati.
                </li>
                <li>
                  Nel messaggi di conferma vi è un tasto che consente, in caso di necessitò, di cancellare la prenotazione.
                  <br>Nel caso sia necessario modificare la prenotazione si consiglia appunto di cancellare la vecchia prenotazione e quindi effettuarne una nuova:
                  <br>Non è consentito infatti avere più prenotazione con lo stesso numero nello stesso giorno.
                </li>
              </ol>
            </v-container>
            <v-container>
              <h3>Scopi della raccolta e memorizzazione dei dati</h3>
              <p>
                I dati raccolti sono conservati in un DataBase sotto il diretto controllo di DEMO
              </p>
              <ol>
                <li>
                  I dati sono raccolti unicamente per l'evasione della richiesta di prenotazione ricevuta e per l'ottimizzazione ed il miglioramento dei servizi offerti da DEMO ed aziende collegate o controllate
                  Nessun dato, nemmeno in forma aggregata ed anonimizzata sarà ceduto, venduto, consegnato a terzi, ne in forma gratuita ne a pagamento o altra forma di remunerazione.
                </li>
                <li>
                  I dati sensibili (Nome e numero WhatsApp) possono essere consevati fino a revoca, mentre gli altri dati possono essere utilizzati anche successivamente ma solo in via aggregata ed anonimizzata a fini statistici, o per il miglioramento ed ottimizzazione dei servizi offerti.
                </li>
                <li>
                  DEMO ed attività collegate e/o partecipate si riservano la facoltà di inviare saltuariamente, informazioni, offerte, promozioni, ed altre attività di marketing, relative alle proprie attività.
                </li>
              </ol>
            </v-container>
            <v-container>
              <h3>DEMOsi riserva di</h3>
              <ol>
                <li>
                  DEMO si riserva il diritto di modificare o terminare il servizio "direct Booking" in qualsiasi momento senza preavviso alcuno e senza dover motivare le proprie decisioni e scelte.
                </li>
                <li>
                  DEMO si riserva la facoltà, nei termini della legge vigente, di cancellare una prenotazione in ogni momento, anche qualora l'ospite sia già nei locali di DEMO, qualora, per qualsiasi motivo ritenga di non poter o non voler prestare il servizio di ristoro oggetto della propria attività. 
                </li>
                <li>
                  DEMO si riseva di cancellare prenotazioni erroneamente accettate dal sistema a causa di bug dell'applicativo stesso, di problemi sul server ove è installato l'applicativo o problemi legati alle connessioni informatiche.
                </li>
              </ol>
            </v-container>
            <v-container>
              <h3>Cancellazione dei Dati Sensibili</h3>
              <ol>
                <li>
                  Ogni utente può cancellare in autonomia i propri dati sensibili dal nostro database in qualunque momento, rispondendo ad un nostro messaggio WhatsApp con la parola "Cancellami" o inviando un messaggio WhatsApp al nostro numero 330 05 05 contenente la parola "Cancellami".
                </li>
              </ol>
            </v-container>            
            <v-container>
              <h3>Limitazione di Responsabilità</h3>
              <p>Inviando la richiesta di prenotazione l'utente espressamente dichiara di aver letto i presenti Termini e Condizioni e dichiara di accetta che:</p>
              <ol>
                <li>
                  DEMO ed propri fornitori non sia responsabile per eventuali danni e costi, diretti ed indiretti, incidentali, speciali o consequenziali di bug di programmazione o problemi tecnici sul server e sulle connessioni informatiche che possano aver erroneamente confermato una prenotazione.
                </li>
                <li>
                  Lo stesso dicasi per eventuale perdita e/o sottrazione di dati sensibili da parte di terzi in violazione dei server e servizi utilizzati per il funzionamento dell'Applicazione
                  In nessun caso DEMO o suoi fornitori o affiliati possa essere ritenuto responsabile per danni emergenti diretti o indiretti e/o lucri cessanti da qualsiasi motivo derivanti, negligenza inclusa.
                </li>
                <li>
                  DEMO ed ognuna delle sue controllanti, controllate, consociate, affiliate, filiali, partners, amministratori, direttori, agenti, impiegati e fornitori non siano ritenute responsabili e non 
                  possano essere citate in tribunale, chiamate in causa, richiesto un accordo extragiudiziale, incluse le richieste di spese legali avanzate da qualsiasi parte anche terza.
                </li>
                <li>
                  L'utente utilizza il servizio offerto a proprio rischio esclusivo. Il servizio è fornito secondo la formula "as is" e “as available”   senza alcuna garanzia e condizione, espressa, implicita od obbligatoria
                </li>
                <li>
                  DEMO non garantisce che il servizio sia continuo, preciso, sicuro o scevro da errori.
                </li>
              </ol>
            </v-container>
            <v-container>
              <h3>Proprietà Intellettuale</h3>
              <ol>
                <li>
                  L'applicativo directBooking è stato sviluppato esclusivamente per DEMO ed è totalmente di sua proprietà. 
                </li>
                <li>
                  E' fatto esplicito divieto qualsiasi uso da parte di terzi non autorizzati, di tutto o di parte del codice che necessariamente è visionabile sul client.
                </li>
              </ol>
            </v-container>
            <v-container>
              <h3>Varie</h3>
              <ol>
                <li>
                  L'applicazione è costruita e pensata per l'utilizzatore umano: ogni uso mediante bot o programmi automatizzati che simulino l'utente sono espressamente vietati.
                </li>
                <li>
                  E' vietato l'uso dell'Applicativo per generare false prenotazioni, sia per motivi ludici che per altri (ovvi) motivi.
                </li>
                <li>
                  Ogni caso di abuso, che abbia non solo creato un danno o mancato guadagn, ma anche semplice disagio o disservizio, o danneggiato l'immagine e la reputazione dell'attività sarà perseguito a termini di legge, e ove sia possibile si elegge il domicilio al tribunale di Genova.
                </li>
                <li>
                  L'utente concorda di non riprodurre, duplicare, copiare, vendere, rivendere, sfruttare alcuna porzione dell'Applicazione e del relativo codice sorgente, o utilizzare il servizio, per motivi diversi dall'effettuare una reale prenotazione tavoli per DEMO.
                </li>
                <li>
                  L'utente conferma di essere a conoscenza che l'uso dell'Applicazione, incluse le sue parti, incluse le informazioni memorizzate o trasmesse da DEMO, sono governate dalle leggi Italiane in vigore alla data d'uso delle stesse.
                </li>
              </ol>
            </v-container>
          </v-container>
        </v-card>
      </v-row>
    </v-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      page: "Termini e Condizioni",
      breadcrumbs: [
        {
          text: "Termini e Condizioni",
          disabled: true,
        },
      ],
    };
  },
};
</script>